import React, { useState } from 'react';
import { XIcon, PlusIcon } from 'lucide-react';
interface TaggingInterfaceProps {
  currentTags: string[];
  onClose: () => void;
}
export function TaggingInterface({
  currentTags,
  onClose
}: TaggingInterfaceProps) {
  const [tags, setTags] = useState<string[]>(currentTags);
  const [newTag, setNewTag] = useState('');
  // More personalized, contextual suggested tags
  const suggestedTags = ['summer 2025', 'Hannah', 'roadtrip France', 'with Alex', 'beach day', 'morning run', 'sunset drive', 'rainy day', 'Central Park', 'spring 2024'];
  const handleAddTag = () => {
    if (newTag.trim() && !tags.includes(newTag.trim())) {
      setTags([...tags, newTag.trim()]);
      setNewTag('');
    }
  };
  const handleRemoveTag = (tagToRemove: string) => {
    setTags(tags.filter(tag => tag !== tagToRemove));
  };
  const handleAddSuggestedTag = (tag: string) => {
    if (!tags.includes(tag)) {
      setTags([...tags, tag]);
    }
  };
  return <div className="fixed inset-0 bg-black/90 z-20 flex items-center justify-center p-4" data-id="element-157">
      <div className="bg-zinc-900 rounded-xl w-full max-w-md p-5" data-id="element-158">
        <div className="flex items-center justify-between mb-5" data-id="element-159">
          <h3 className="text-lg font-bold" data-id="element-160">Edit Tags</h3>
          <button onClick={onClose} className="text-zinc-400" data-id="element-161">
            <XIcon size={20} data-id="element-162" />
          </button>
        </div>
        {/* Current tags */}
        <div className="mb-5" data-id="element-163">
          <p className="text-sm text-zinc-400 mb-2.5" data-id="element-164">Current Tags</p>
          <div className="flex flex-wrap gap-2" data-id="element-165">
            {tags.length > 0 ? tags.map(tag => <div key={tag} className="px-3 py-1.5 bg-zinc-800 rounded-full text-sm flex items-center" data-id="element-166">
                  <span data-id="element-167">{tag}</span>
                  <button className="ml-2 text-zinc-400 hover:text-white" onClick={() => handleRemoveTag(tag)} data-id="element-168">
                    <XIcon size={14} data-id="element-169" />
                  </button>
                </div>) : <p className="text-xs text-zinc-500" data-id="element-170">No tags added yet</p>}
          </div>
        </div>
        {/* Add new tag */}
        <div className="mb-5" data-id="element-171">
          <p className="text-sm text-zinc-400 mb-2.5" data-id="element-172">Add New Tag</p>
          <div className="flex" data-id="element-173">
            <input type="text" value={newTag} onChange={e => setNewTag(e.target.value)} placeholder="Add a personal tag..." className="flex-1 bg-zinc-800 border border-zinc-700 rounded-l-md px-3 py-2.5 text-sm focus:outline-none focus:border-green-500" onKeyDown={e => {
            if (e.key === 'Enter') handleAddTag();
          }} data-id="element-174" />
            <button onClick={handleAddTag} className="bg-green-500 text-black px-3.5 rounded-r-md flex items-center" data-id="element-175">
              <PlusIcon size={18} data-id="element-176" />
            </button>
          </div>
        </div>
        {/* Suggested tags */}
        <div data-id="element-177">
          <p className="text-sm text-zinc-400 mb-2.5" data-id="element-178">Your Recent Tags</p>
          <div className="flex flex-wrap gap-2" data-id="element-179">
            {suggestedTags.map(tag => <button key={tag} onClick={() => handleAddSuggestedTag(tag)} className={`px-3 py-1.5 rounded-full text-sm ${tags.includes(tag) ? 'bg-green-500/20 text-green-500 border border-green-500/30' : 'bg-zinc-800 text-zinc-300'}`} data-id="element-180">
                {tag}
              </button>)}
          </div>
        </div>
        <button onClick={onClose} className="w-full bg-green-500 text-black font-medium rounded-md py-2.5 mt-6" data-id="element-181">
          Save
        </button>
      </div>
    </div>;
}